const highlihtedProjects = [
  {
    name: 'CockroachDB To-Do Apps',
    description:
      'Code newbies and new open source contributors -- help us build our repository of sample apps by building a To-Do app using CockroachDB and a language/ORM of your choice.',
    url: 'https://github.com/cockroachdb/cockroachdb-todo-apps',
    languages: ['javascript', 'python', 'golang', 'ruby', 'rust', 'php'],
  },
  {
    name: 'TidyTweets',
    description:
      'A Twitter companion app focused on privacy settings and organization.',
    url: 'https://github.com/rlueder/tidytweets/',
    languages: ['javascript'],
  },
];

export default highlihtedProjects;
